import React from 'react'
import "./blog.css";

import HeaderBlogMain from "../blog/HeaderBlogMain";
import BodyBlogMain from "../blog/BodyBlogMain";
import Footer2 from "../footer2/Footer2";

function Blog() {
  return (
    <section>
       <div id='blog-NavApp'>
            <HeaderBlogMain/>
       </div>
       
       <BodyBlogMain/>
       <Footer2/>
    </section>
  )
}

export default Blog